import { useApp } from "@/contexts";
import { getFeatureValue } from "@/utils";
import { useMemo } from "react";

// hooks/useNumericFeature.ts
export const useNumericFeature = (featureCode: string) => {
  const { getAppPlanFeature } = useApp();

  const feature = getAppPlanFeature(featureCode);

  const maxValue = useMemo(() => {
    if (!feature) return 0;
    const value = getFeatureValue(
      feature.featureValue,
      feature.featureValueType
    );
    return typeof value === "number" ? value : 0;
  }, [feature]);

  return {
    feature,
    maxValue,
    isEnabled: maxValue > 0,
  };
};
